import { siteNames } from '@seek/melways-sites';

export const SITE_DEFAULT = siteNames.employer.seek.au;
